/**
 * main.js
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

import { registerPlugins } from '#plugins/index.js'

// Components
import AppVue from '#components/app/app.vue'

// Composables
import { createApp } from 'vue'

// Styles
import 'unfonts.css'

import { store } from '#models/store.js'

async function goApp() {
    const app = createApp(AppVue)
    registerPlugins(app)
    await store.dbinit()    
    app.mount('#app')
}

goApp()